import p1_img from './1.jpg'
import p2_img from './2.jpg'
import p3_img from './3.jpg'
import p4_img from './4.jpg'






let data = [
  {
      id: 1,
      name: "Where artistry meets elegance: A hand-embroidered black chiffon dream.",
      image: p1_img,
      new_price: 6999,
      old_price: 8999,
      //  images: [p1_img, p1_1_img, p1_2_img, p1_3_img],
  
    },
    {
      id: 2,
      name: "Mystical elegance: Where purple chiffon dances with hand-embroidered artistry",
      image: p2_img,
      new_price: 6999,
      old_price: 8999,
      //  images: [p2_img, p2_1_img, p2_2_img, p2_3_img],
    },
    {
      id: 3,
      name: "Like a cloud of dreams: Sky blue chiffon, hand-embroidered with ethereal grace",
      image: p3_img,
      new_price: 6499,
      old_price: 7999,
      //  images: [p3_img, p3_1_img, p3_2_img, p3_3_img],
    },
    {
      id: 4,
      name: "A breath of springtime: Hand-embroidered pastel green chiffon, a vision of fresh elegance",
      image: p4_img,
      new_price: 6799,
      old_price: 8499,
      //  images: [p4_img, p4_2_img, p4_3_img, p4_4_img],
    }
];

export default data;
